module.exports = __webpack_public_path__ + "static/media/ItemDetailsScreen.a0960aa6.png";